const ROOT = '/operatories';

const routes = {
  overview: () => ROOT
};

export default routes;
